import instance from "../axios";
import * as endpoints from "./endpoints";
import { AUTHORIZATION_KEY } from "../global_constants";

export const logFrontendApiError = (payload) => {
  let path = endpoints.LOG_FRONTEND_API_ERROR_API_PATH;
  return instance.post(path, payload);
}

export const registerUser = (payload) => {
  delete instance.defaults.headers.common["Authorization"];
  return new Promise((resolve, reject) => {
    instance
      .post(endpoints.REGISTER_API_PATH, payload)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const loginUser = (payload) => {
  delete instance.defaults.headers.common["Authorization"];
  return new Promise((resolve, reject) => {
    instance
      .post(endpoints.LOGIN_API_PATH, payload)
      .then((response) => {
        const { data } = response;
        instance.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${data.access_token}`;
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getAuthUserDetail = () => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem(AUTHORIZATION_KEY);
    if (token) {
      instance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      instance
        .get(endpoints.AUTH_USER_API_PATH)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    } else {
      reject();
    }
  });
};

export const getSettings = () => {
  let path = endpoints.GET_SETTINGS_API_PATH;
  return instance.get(path);
}
export const editSettings = (payload) => {
  let path = endpoints.EDIT_SETTINGS_API_PATH
  return instance.post(path, payload);
};

export const getAccount = () => {
  let path = endpoints.GET_ACCOUNT_API_PATH;
  return instance.get(path);
}
export const getApiKey = () => {
  let path = endpoints.API_KEY_API_PATH;
  return instance.get(path);
};
export const editAccount = (payload) => {
  let path = endpoints.EDIT_ACCOUNT_API_PATH
  return instance.post(path, payload);
};
export const getAccountBasicUsageStats = () => {
  let path = endpoints.ACCOUNT_BASIC_USAGE_STATS;
  return instance.get(path);
};

export const getUsageHistory = (params = null) => {
  let path = endpoints.GET_USAGE_HISTORY_API_PATH;
  return instance.get(path);
}

export const getAllUsers = () => {
  let path = endpoints.GET_ALL_USERS_API_PATH;
  return instance.get(path);
};
export const getFilteredUsers = (params) => {
  let path = endpoints.GET_ALL_FILTERED_USERS_API_PATH;
  if (params) path = path + "?" + params;
  return instance.get(path);
}
export const getSingleUser = (userId) => {
  let path = endpoints.GET_SINGLE_USER_API_PATH.replace("{userId}", userId);
  return instance.get(path);
};
export const addUser = (payload) => {
  let path = endpoints.ADD_USERS_API_PATH;
  return instance.post(path, payload);
};
export const editUser = (payload, userId) => {
  let path = endpoints.EDIT_USER_API_PATH.replace("{userId}", userId);
  return instance.post(path, payload);
};
export const deleteUser = (userId) => {
  let path = endpoints.DELETE_USER_API_PATH.replace("{userId}", userId);
  return instance.delete(path);
};

export const removeBackground = (payload) => {
  let path = endpoints.REMOVE_BACKGROUND_API_PATH;
  return instance.post(path, payload, { headers: { "Content-Type": "multipart/form-data" } });
};
